import React from 'react';
import { Input } from '../../../components/ui/Input';
import { Select } from '../../../components/ui/Select';
import { Button } from '../../../components/ui/Button';
import { SUPPORTED_LANGUAGES } from '../constants';

/**
 * Reusable Translation Form Component
 * Used for Post, Category, and Tag translations
 */
function TranslationForm({ translations, onChange, fields = ['name'] }) {
  const handleTranslationChange = (index, field, value) => {
    const newTranslations = [...translations];
    newTranslations[index] = {
      ...newTranslations[index],
      [field]: value
    };
    onChange(newTranslations);
  };

  const handleLanguageChange = (index, languageCode) => {
    const newTranslations = [...translations];
    newTranslations[index] = {
      ...newTranslations[index],
      language_code: languageCode
    };
    onChange(newTranslations);
  };

  const handleAddTranslation = () => {
    const newTranslation = {
      language_code: 'tr',
      ...fields.reduce((acc, field) => ({ ...acc, [field]: '' }), {})
    };
    onChange([...translations, newTranslation]);
  };

  const handleRemoveTranslation = (index) => {
    if (translations.length <= 1) return;
    const newTranslations = translations.filter((_, i) => i !== index);
    onChange(newTranslations);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider">Çeviriler</h3>
        <Button variant="ghost" size="sm" onClick={handleAddTranslation} type="button">
          + Çeviri Ekle
        </Button>
      </div>

      {translations.map((translation, index) => (
        <div key={index} className="p-4 rounded-lg bg-zinc-900 border border-zinc-800 space-y-4 relative group">
          {translations.length > 1 && (
            <button
              onClick={() => handleRemoveTranslation(index)}
              className="absolute top-2 right-2 text-gray-500 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
              type="button"
            >
              ×
            </button>
          )}

          <div className="space-y-1.5">
            <label className="text-xs text-gray-500 uppercase font-semibold">Dil Seçimi</label>
            <Select
              value={translation.language_code}
              onChange={(e) => handleLanguageChange(index, e.target.value)}
            >
              {SUPPORTED_LANGUAGES.map(lang => (
                <option key={lang} value={lang}>
                  {lang.toUpperCase()}
                </option>
              ))}
            </Select>
          </div>

          <div className="grid gap-4">
            {fields.map((field) => (
              <div key={field} className="space-y-1.5">
                <label className="text-xs text-gray-500 uppercase font-semibold">{getFieldLabel(field)}</label>
                {field === 'content' || field === 'description' ? (
                  <textarea
                    className="flex w-full rounded-md border border-zinc-800 bg-zinc-950 px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 min-h-[100px]"
                    value={translation[field] || ''}
                    onChange={(e) => handleTranslationChange(index, field, e.target.value)}
                    rows={field === 'content' ? 6 : 3}
                  />
                ) : (
                  <Input
                    value={translation[field] || ''}
                    onChange={(e) => handleTranslationChange(index, field, e.target.value)}
                    placeholder={getFieldLabel(field)}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function getFieldLabel(field) {
  const labels = {
    name: 'İsim',
    title: 'Başlık',
    content: 'İçerik',
    excerpt: 'Özet',
    description: 'Açıklama',
    meta_title: 'Meta Başlık',
    meta_description: 'Meta Açıklama',
    meta_keywords: 'Meta Anahtar Kelimeler'
  };
  return labels[field] || field;
}

export default TranslationForm;

